import "./CustomSwitch.css";
import { notifyError, notifySuccess } from "../../utilities/helper";
import { useNavigate } from "react-router-dom";
const CustomAPISwitch = ({
  isSwitch,
  api,
  data,
  onScrollKey,
  fetchOriginalData,
  roleId = null,
}) => {
  const access_token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const handleSwitchChange = async (data) => {
    onScrollKey?.();
    try {
      const res = await api(data, access_token);
      if (res?.status === 200) {
        notifySuccess("Updated successfully");
        fetchOriginalData(roleId ? roleId : data?.roleId);
      } else {
        notifyError("Failed to update");
      }
    } catch (err) {
      console.log(err);
      notifyError("Failed to update");
      if (err.status === 401) {
        navigate("/unauthorize");
      }
    }
  };
  return (
    <div>
      <label className="switch">
        <input
          type="checkbox"
          checked={isSwitch}
          onChange={() => {
            handleSwitchChange(data);
          }}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default CustomAPISwitch;
